import { useMutation, MutationFunctionOptions } from '@apollo/client'

import registerPatientMutation from '@/mutations/registerPatient'
import appConfig from '../config'
import { RegisterPatientPayload, RegisterPatientInput } from '@/types'

type RegisterPatientResponse = any

const useRegisterPatient = () => {
  const [registerPatient] = useMutation<
    RegisterPatientResponse,
    RegisterPatientPayload
  >(registerPatientMutation)

  const doRegisterPatient = async (input: RegisterPatientInput) => {
    const { PLATFORM_GATEWAY_URL } = appConfig
    const inputData: RegisterPatientPayload = {
      input,
    }
    const registerUserParams: MutationFunctionOptions<
      RegisterPatientResponse,
      RegisterPatientPayload
    > = {
      context: {
        showFeedback: false,
        uri: PLATFORM_GATEWAY_URL,
      },
      variables: inputData,
    }

    const result = await registerPatient(registerUserParams)

    return result.data.registerPatient
  }

  return {
    registerPatient: doRegisterPatient,
  }
}

export default useRegisterPatient
